export const ReservationCheckPageIDs = {
  phoneInput: 'phoneInput_textinput',
  emailInput: 'emailInput',
} as const;
